<template>
  <div class="mb-10">
    <v-container>
      <v-alert
        outlined
        color="indigo"
        border="left"
        dense
      >
        <p class="mb-3 title font-weight-medium">
          Здравствуйте, {{abiturient.first_name}}!
        </p>
        <p class="mb-2 text-body-2">
          Мы рады приветствовать вас на сайте дистанционного приема заявлений на поступление в
          «Кузбасский государственный технический университет имени Т.Ф.&nbsp;Горбачева».
        </p>
        <p class="mb-2 text-body-2">
          Если у вас возникнут трудности при работе с данным сайтом, пожалуйста, свяжитесь с приемной комиссией КузГТУ
          любым
          удобным для вас способом из указаных в нижней части сайта.
        </p>
        <p class="mb-0 text-body-2">
          Желаем вам успехов в поступлении!
        </p>
      </v-alert>

      <h1 class="text-h5 font-weight-light mb-2">Персональные данные</h1>
      <v-stepper v-model="step" vertical class="pb-4">

        <!-- STEP 0 -->

        <v-stepper-step color="indigo" :complete="step > 0" step="0">
          Подтверждение электронной почты
        </v-stepper-step>
        <v-stepper-content :v-if="step === 0" step="0">
          <v-card flat>
            <v-sheet class="body-2 text--secondary pb-4">
              <p class="mb-1">
                На указанный вами при регистрации адрес электронной почты <span
                class="font-weight-bold">{{user.email}}</span> отправлено письмо!
              </p>
              <p class="mb-1">Продолжить работу можно только после перехода по указанной в письме ссылке.</p>
              <p class="mb-1">Если письмо не пришло вам в течение 15 минут после регистрации, повторите отправку
                письма.</p>
              <p class="mb-0">Если при регистрации вами была допущена ошибка в адресе электронной почты,
                зарегистрируйтесь повторно.</p>
            </v-sheet>
          </v-card>
          <v-btn
            class="lighten-1"
            color="indigo"
            :disabled="countDown > 0"
            @click="sendEmail"
            text
            v-html="countDown === 0 ? 'Отправить письмо' : 'Подождите: ' + countDown"
          >
          </v-btn>
        </v-stepper-content>

        <!-- STEP 1 -->

        <v-stepper-step :editable="step > 1" color="indigo" :complete="step > 1" step="1">
          Согласия на обработку и распространение персональных данных
        </v-stepper-step>
        <v-stepper-content :v-if="step === 1" step="1">
          <v-card flat>
            <v-sheet class="body-2 text--secondary pb-4">
              <ol>
                <li>Выберите подходящий вариант, один из двух, скачайте и распечатайте <span class="font-weight-bold">бланки согласий</span>
                  на обработку и распоространение персональных данных:
                  <ul>
                    <li class="my-1">
                      <a class="font-weight-regular indigo--text"
                         v-bind:href="'/files/personal/Согласие_на_обработку_и_распространение_ПДн_совершеннолетнего_поступающего_в_КузГТУ.pdf'"
                         target="_blank"
                      >Скачать</a> бланки согласий на обработку и распространение персональных данных <span class="font-weight-bold">совершеннолетнего</span> поступающего.
                    </li>
                    <li class="my-1">
                      <a class="font-weight-regular indigo--text"
                         v-bind:href="'/files/personal/Согласие_на_обработку_и_распространение_ПДн_несовершеннолетнего_поступающего_в_КузГТУ.pdf'"
                         target="_blank"
                      >Скачать</a> бланки согласий на обработку и распространение персональных данных <span class="font-weight-bold">несовершеннолетнего</span> поступающего.
                    </li>
                  </ul>
                </li>
                <li>
                  Заполните все поля в бланках согласий
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span class="text--secondary" style="border-bottom: 1px dashed" v-on="on">"от руки"</span>
                    </template>
                    <span>Собственноручно, ручкой с синей или черной пастой</span>
                  </v-tooltip>
                  и заверьте документы личной подписью с расшифровкой.
                </li>
                <li>Создайте
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span class="text--secondary" style="border-bottom: 1px dashed" v-on="on">электронную копию</span>
                    </template>
                    Фотография с телефона или скан-копия документа (.png, .jpg, .jpeg, .pdf).
                    Качество изображений должно обеспечивать читаемость информации.
                  </v-tooltip>
                  согласия и прикрепите в поле "Выбрать файл".
                </li>
              </ol>
              <!-- <p>-&#45;&#45; Ваш возраст: {{abiturient.age}} (для формы, кому меньше 18 лет и нужно согласие родителей)</p>-->
            </v-sheet>
            <file-input
              ref="type1Files"
              :multiple=true
              :type="1"
              :max-files="5"
            ></file-input>
            <v-btn
              dark
              class="mt-5 lighten-1"
              color="indigo"
              @click="toStep2"
              :loading="isLoading"
            >
              Далее
            </v-btn>
          </v-card>
        </v-stepper-content>

        <!-- STEP 2 -->

        <v-stepper-step :editable="step > 2" color="indigo" :complete="step > 2" step="2">Телефоны</v-stepper-step>
        <v-stepper-content :v-if="step === 2" step="2">
          <v-sheet class="body-2 text--secondary pb-4">
            <p>Пожалуйста, указывайте телефоны в международном формате:</p>
            <p class="mb-1">Например:</p>
            <ul>
              <li>+7-ХХХ-ХХХ-ХХХХ - Российская Федерация</li>
              <li>+7-ХХХ-ХХХ-ХХХХ - Казахстан</li>
            </ul>
          </v-sheet>
          <contacts-form
            ref="contactForm"
          ></contacts-form>
          <v-btn
            class="mt-5 lighten-1"
            color="indigo"
            dark
            @click="toStep3">
            Далее
          </v-btn>
        </v-stepper-content>

        <!-- STEP 3 -->

        <v-stepper-step :editable="step > 3" color="indigo" :complete="step > 3" step="3">
          Документ, удостоверяющий личность
        </v-stepper-step>
        <v-stepper-content :v-if="step === 3" step="3">
          <v-card flat>
            <v-sheet class="body-2 text--secondary">
              <p>Создайте
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span class="text--secondary" style="border-bottom: 1px dashed" v-on="on">электронную копию</span>
                  </template>
                  Фотография с телефона или скан-копия документа (.png, .jpg, .jpeg, .pdf).
                  Качество изображений должно обеспечивать читаемость информации.
                </v-tooltip>
                документа, удостоверяющего личность (паспорта), и прикрепите в поле "Выбрать файл".
              </p>
              <p class="mb-2">Следующие страницы:</p>
              <ul class="pb-0">
                <li>Разворот с регистрационными данными и фотографией</li>
                <li>Cтраницы со сведениями о месте жительства</li>
              </ul>
            </v-sheet>
            <file-input
              ref="type2Files"
              :multiple=true
              :type="2"
            ></file-input>
            <v-btn
              dark
              class="mt-5 lighten-1"
              color="indigo"
              @click="toStep4"
              :loading="isLoading"
            >
              Далее
            </v-btn>
          </v-card>
        </v-stepper-content>

        <!-- STEP 4 -->

        <v-stepper-step :editable="step > 4" color="indigo" :complete="step > 4" step="4">
          Документ о предыдущем образовании
        </v-stepper-step>
        <v-stepper-content :v-if="step === 4" step="4">
          <v-card flat>
            <v-card-subtitle>
              <p>Создайте
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span class="text--secondary" style="border-bottom: 1px dashed" v-on="on">электронную копию</span>
                  </template>
                  Фотография с телефона или скан-копия документа (.png, .jpg, .jpeg, .pdf).
                  Качество изображений должно обеспечивать читаемость информации.
                </v-tooltip>
                документа о предыдущем образовании (включая приложение) и прикрепите в поле "Выбрать файл".
              </p>
            </v-card-subtitle>
            <v-card-text>
              <file-input
                ref="type3Files"
                :multiple=true
                :type="3"
              ></file-input>
              <v-switch v-model="eduDocApprove" class="pt-5">
                <template v-slot:label>
                  <div>
                    Мои
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <span class="text--secondary" style="border-bottom: 1px dashed" v-on="on">данные</span>
                      </template>
                      Фамилия, имя, отчество
                    </v-tooltip>
                    в документе о предыдущем образовании отличаются от указаных в документе, удостоверяющем личность
                  </div>
                </template>
              </v-switch>
              <v-card-subtitle v-if="eduDocApprove">
                <p class="pb-0 text-justify">Создайте
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span class="text--secondary" style="border-bottom: 1px dashed" v-on="on">электронную копию</span>
                    </template>
                    Фотография с телефона или скан-копия документа (.png, .jpg, .jpeg, .pdf).
                    Качество изображений должно обеспечивать читаемость информации.
                  </v-tooltip>
                  документа, на основании которого произведено изменение данных и прикрепите в поле "Выбрать файл".
                </p>
                <file-input
                  ref="type4Files"
                  :multiple=true
                  :type="4"
                  :validate="eduDocApprove"
                ></file-input>
              </v-card-subtitle>

              <v-switch v-model="egeDiff">
                <template v-slot:label>
                  <div>
                    Мои
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <span class="text--secondary" style="border-bottom: 1px dashed" v-on="on">данные</span>
                      </template>
                      Фамилия, имя, отчество
                    </v-tooltip>
                    на ЕГЭ отличаются от указаных в документе, удостоверяющим личность (паспорте)
                  </div>
                </template>
              </v-switch>
              <v-card-subtitle v-if="egeDiff">
                <p class="pb-0 text-justify">
                  Если зарегистрированные на ЕГЭ данные отличаются от сведений по действующему документу,
                  удостоверяющему личность приведите их в соответствующих полях
                </p>
                <ege-diff-form
                  ref="egeDiffForm"
                  :validate="egeDiff"
                >

                </ege-diff-form>
                <p class="pb-0 text-justify">Если вы были зарегистрированы на ЕГЭ по другому документу, создайте
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span class="text--secondary" style="border-bottom: 1px dashed" v-on="on">электронную копию</span>
                    </template>
                    Фотография с телефона или скан-копия документа (.png, .jpg, .jpeg, .pdf).
                    Качество изображений должно обеспечивать читаемость информации.
                  </v-tooltip>
                  страницы действующего документа, удостоверяющего личность (паспорта),
                  с информацией о документе (паспорте), зарегистрированном на ЕГЭ, прикрепите полученный файл
                </p>
                <file-input
                  ref="type8Files"
                  :max-files="10"
                  :type="8"
                  :validate="false"
                ></file-input>
              </v-card-subtitle>
            </v-card-text>

          </v-card>

          <v-sheet>
            <p class="text--secondary body-2">
              Нажимая кнопку «Сохранить», вы завершаете ввод своих персональных данных и переходите в раздел подачи
              заявлений на поступление в «Кузбасский государственный технический университет имени Т.Ф. Горбачева».
            </p>
            <v-btn
              dark
              class="lighten-1"
              color="success"
              @click="submit"
              :loading="isLoading"
            >
              Сохранить
            </v-btn>
          </v-sheet>

        </v-stepper-content>
      </v-stepper>
    </v-container>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";
  import {mdiCamera, mdiClose, mdiFileDocument, mdiPrinter, mdiSchool, mdiTextBoxCheckOutline,} from "@mdi/js";
  import FileInput from "@/components/profile/FileInput";
  import ContactsForm from "@/components/profile/personals/ContactsForm";
  import EgeDiffForm from "@/components/profile/personals/EgeDiffForm";

  export default {
    name: "Personal",
    components: {EgeDiffForm, ContactsForm, FileInput},
    data() {
      return {
        icons: {
          mdiSchool,
          mdiClose,
          mdiFileDocument,
          mdiPrinter,
          mdiCamera,
          mdiTextBoxCheckOutline,
        },
        countDown: 0,
        eduDocApprove: false,
        egeDiff: false,
      }
    },
    created() {
      this.$store.dispatch("abiturient/loadAbiturient")
    },
    computed: {
      ...mapGetters("auth", ['user']),
      ...mapGetters("abiturient", ['abiturient']),
      ...mapGetters("context", ['isLoading']),
      ...mapGetters("filemanager", ["uploadedFiles"]),
      step: {
        get() {
          return this.abiturient.personal_data_step
        },
        set(value) {
          this.$store.commit("abiturient/UPDATE_ABITURIENT_MODEL", {personal_data_step: value})
          this.$store.dispatch("abiturient/update")
        }
      },
    },
    methods: {
      // Согласие на обработку персональных данных
      async toStep2() {
        const fileInput = this.$refs.type1Files
        await fileInput.validateFiles().then(() => {
          if (fileInput.isSuccess) {
            this.step = 2
            fileInput.isSuccess = false
          }
        })
      },

      // Телефоны
      async toStep3() {
        const from = this.$refs.contactForm
        await from.submit().then(() => {
          if (from.isSuccess) {
            this.step = 3
            from.isSuccess = false
          }
        })
      },

      // Документ удостоверяющий личность
      async toStep4() {
        const fileInput = this.$refs.type2Files
        await fileInput.validateFiles().then(() => {
          if (fileInput.isSuccess) {
            this.step = 4
            fileInput.isSuccess = false
          }
        })
      },

      // Документ о предыдущем образовании
      async submit() {
        const fileInput = this.$refs.type3Files
        const approveFileInput = this.$refs.type4Files
        const egeFileInput = this.$refs.type8Files
        const egeDiffForm = this.$refs.egeDiffForm

        let success1 = false
        let success2 = true
        let success3 = true
        await fileInput.validateFiles().then(() => {
          success1 = fileInput.isSuccess;
        })
        if (this.eduDocApprove) {
          success2 = false
          await approveFileInput.validateFiles().then(() => {
            if (approveFileInput.isSuccess) {
              success2 = true
            }
          })
        }
        if (this.egeDiff) {
          success3 = false
          await Promise.all([
            egeDiffForm.submit(),
            egeFileInput.validateFiles(),
          ]).finally(() => {
            if (egeDiffForm.isSuccess || egeFileInput.isSuccess) {
              success3 = true
            }
          })
        }

        if (success1 && success2 && success3) {
          this.completed()
        }

      },
      completed() {
        this.$store.commit("abiturient/UPDATE_ABITURIENT_MODEL", {personal_data_completed: true})
        this.$store.dispatch("abiturient/update").then(() => {
          this.$router.push({name: 'profile_application_list'})
        })
      },
      sendEmail() {
        this.$store.dispatch("auth/send_email_activation")
          .then(() => {
            this.countDown = 360;
            this.countDownTimer()
          })
          .catch(() => {
          })
      },
      countDownTimer() {
        if (this.countDown > 0) {
          setTimeout(() => {
            this.countDown -= 1
            this.countDownTimer()
          }, 1000)
        }
      }
    }
  }
</script>

<style scoped>

</style>
